import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { actionCreators } from "../redux/totalRevenueSalesSagas";

const IncludeReturns = () => {
  const dispatch = useDispatch();
  const include_returns = useSelector(
    (state) => state.totalRevenueSales.selectedFilters.include_returns
  );

  return (
    <ToggleableButton
      isActive={include_returns}
      isRadio
      title="total-revenue-sales-toggle-revenue"
      onClick={(data) => dispatch(actionCreators.updateShowNetRevenue(data))}
    />
  );
};

export default IncludeReturns;
